/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {TOKENS} from '../../components/design-system'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) root.style.height = '100%'
    return () => { if (root) root.style.height = 'auto' }
  }, [])

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      background: TOKENS.color.surface,
    }}>
      {/* Hero column (image + tagline) */}
      <div style={{
        flex: 1,
        minWidth: 0,
        backgroundImage: `linear-gradient(135deg, rgba(37,99,235,0.85), rgba(17,24,39,0.75)), url(${toAbsoluteUrl('/media/misc/login_bg.webp')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
        color: '#fff',
      }}
        className='d-none d-lg-flex'
      >
        <div style={{ maxWidth: 460 }}>
          <div style={{
            fontSize: TOKENS.typography.label.size,
            fontWeight: TOKENS.typography.label.weight,
            textTransform: TOKENS.typography.label.transform,
            letterSpacing: TOKENS.typography.label.tracking,
            opacity: 0.85,
            marginBottom: TOKENS.spacing.md,
          }}>
            CMB
          </div>
          {/* H1 + P need explicit color — the parent container has
              color:'#fff' but Metronic's global "text-gray-900" /
              tag-level h1 styles win otherwise, leaving the title
              illegible (dark text on the dark hero image). */}
          <h1 style={{
            fontSize: 32,
            fontWeight: 700,
            lineHeight: 1.25,
            margin: 0,
            letterSpacing: -0.5,
            color: '#fff',
          }}>
            Soluções em Sistemas de Energia Elétrica
          </h1>
          <p style={{
            marginTop: TOKENS.spacing.md,
            fontSize: 14,
            lineHeight: 1.6,
            opacity: 0.85,
            color: '#fff',
          }}>
            Monitoramento em tempo real, gerenciamento remoto e histórico
            completo das suas caixas de medição.
          </p>
        </div>
      </div>

      {/* Form column */}
      <div style={{
        width: '100%',
        maxWidth: 540,
        background: TOKENS.color.card,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '40px',
      }}>
        <Link to='/' style={{ display: 'inline-flex', justifyContent: 'center', marginBottom: TOKENS.spacing.xl }}>
          <img
            alt='Logo CMB'
            src={toAbsoluteUrl('/media/logos/logo-cmb-v3.png')}
            style={{ height: 80, objectFit: 'contain' }}
          />
        </Link>

        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: '100%', maxWidth: 380 }}>
            <Outlet />
          </div>
        </div>

        {/* Footer simplificado — antes tinha links Termos / Planos /
            Contato que apontavam pra páginas inexistentes ou "#". A
            copy ficou só com o copyright pra não confundir o usuário. */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          fontSize: 12,
          color: TOKENS.color.muted,
          marginTop: TOKENS.spacing.xl,
        }}>
          2026&copy; CMBlindada
        </div>
      </div>
    </div>
  )
}

export {AuthLayout}
